import * as Yup from 'yup';
import { PRIVILEGES } from 'utils/globalConst';
import messages from 'containers/SignupPages/AuthByContract/messages';
import { translate } from 'helpers/intl';
import { isDrpp, isNumAdhesion } from 'utils/amcUtils';

export default (props: any) =>
  Yup.object().shape({
    typeAssurance: Yup.string().required(
      translate({ ...messages.requiredField }, props),
    ),
    numPolice: Yup.string()
      .notRequired()
      .when('typeAssurance', {
        is: (typeAssurance) => {
          return (
            typeAssurance === PRIVILEGES.AUTO ||
            typeAssurance === PRIVILEGES.MRH
          );
        },
        then: Yup.string().required(
          translate({ ...messages.requiredField }, props),
        ),
        otherwise: Yup.string().notRequired(),
      }),
    dateEffet: Yup.string()
      .notRequired()
      .when('typeAssurance', {
        is: (typeAssurance) => {
          return (
            typeAssurance === PRIVILEGES.AUTO ||
            typeAssurance === PRIVILEGES.MRH ||
            typeAssurance === PRIVILEGES.ASI
          );
        },
        then: Yup.string().required(
          translate({ ...messages.requiredField }, props),
        ),
        otherwise: Yup.string().notRequired(),
      }),
    organization: Yup.object()
      .nullable()
      .when('typeAssurance', {
        is: (typeAssurance) => typeAssurance === PRIVILEGES.AMC,
        then: Yup.object().required(translate(messages.requiredField, props)),
        otherwise: Yup.object().nullable(),
      }),
    drpp: Yup.string()
      .notRequired()
      .when('organization', {
        is: (organization) => organization && isDrpp(organization.isdrpp),
        then: Yup.string().required(translate(messages.requiredField, props)),
        otherwise: Yup.string().nullable(),
      }),
    membershipNumber: Yup.string()
      .notRequired()
      .when('organization', {
        is: (organization) =>
          organization &&
          isNumAdhesion(organization.numAdhesion, organization?.isdrpp),
        then: Yup.string().required(translate(messages.requiredField, props)),
        otherwise: Yup.string().nullable(),
      }),
  });
